    <template>
    <!-- Page Content -->
    <div id='page-wrapper'>
      <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
        <div class='row'>
          <div class='col-lg-12'>
            <h1 class='page-header'>تقرير بالفنيين و المفوضين</h1>
          </div>
          <!-- /.col-lg-12 -->
        </div>
        <!-- /.row -->
        <div class='row'>
          <div class='col-lg-12'>
            <div class='panel panel-default'>
              <div class='panel-heading'>
              هنا يتم عرض اعمال الفنيين والمفوضين بين تاريخين
              </div>
              <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
                <ul v-if='validationErrors'>
                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class="row">
                <div class='col-lg-12' style="padding: 20px">
                <div class='form-group col-lg-2 col-md-3 col-sm-6' style="padding: 0px 5px">
                  <div class="form-group input-group" style='margin: 0px'>
                    <span class="input-group-addon" style='padding:5px;'>الفرع:</span>
                    <select @change='getEmp()' class="form-control" style="padding: 0px" v-model="branche_id" id='t01'>
                      <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class='form-group col-lg-2 col-md-3 col-sm-6' style="padding: 0px 5px">
                    <div class="form-group input-group" style='margin: 0px'>
                      <span class="input-group-addon" style='padding:5px;'>النوع:</span>
                      <select @change='getEmp()' class="form-control" style="padding: 0px" v-model="typeID" id='t02'>>
                        <option v-for="item in types" :key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class='form-group col-lg-2 col-md-3 col-sm-6' style="padding: 0px 5px">
                  <div class="form-group input-group" style='margin: 0px'>
                    <span class="input-group-addon" style='padding:5px;'>الموظف:</span>
                    <select class="form-control" style="padding: 0px" v-model="user_id" id='t03'>
                      <option v-for="(item) in emps" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class='form-group col-lg-2 col-md-3 col-sm-6' style="padding: 0px 5px">
                  <div class="form-group input-group" style='margin: 0px'>
                    <span class="input-group-addon" style='padding:5px;'>من:</span>
                    <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='from_date'></Datepicker>
                  </div>
                </div>
                <div class='form-group col-lg-2 col-md-3 col-sm-6' style="padding: 0px 5px">
                  <div class="form-group input-group" style='margin: 0px'>
                    <span class="input-group-addon" style='padding:5px;'>الى:</span>
                    <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='to_date'></Datepicker>
                  </div>
                </div>
                <div class='form-group col-lg-1 col-md-2 col-sm-3' style="padding: 0px 5px">
                  <button @click='GetData' type='button' class='btn btn-primary btn-block'>عرض</button>
                </div>
                <div class='form-group col-lg-1 col-md-2 col-sm-3' style="padding: 0px 5px">
                    <button v-simple-print="'contentToPrint'"  type='button' class='btn btn-primary btn-block'>طباعة</button>
                </div>
              </div>
            </div>
              <!-- /.panel-heading -->
              <div class='panel-body'  id="contentToPrint">
                <div class="row">
                  <div class='form-group col-lg-3 col-md-3 col-sm-12'>
                    الفرع: {{t01}}
                    </div>
                    <div class='form-group col-lg-2 col-md-2 col-sm-12'>
                      النوع: {{t02}}
                      </div>
                      <div class='form-group col-lg-3 col-md-3 col-sm-12'>
                        الاسم: {{t03}}
                        </div>
                        <div class='form-group col-lg-2 col-md-2 col-sm-12'>
                          من: {{dateFrom}}
                          </div>
                          <div class='form-group col-lg-2 col-md-2 col-sm-12'>
                            الي: {{dateTo}}
                            </div>
                </div>
                <table  width='100%' class='table table-striped table-bordered table-hover'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>ك.العميل</th>
                      <th style='text-align: center'>اسم العميل</th>
                      <th style='text-align: center'>التاريخ</th>
                      <th style='text-align: center'>المنتج</th>
                      <th style='text-align: center'>م.التركيب</th>
                      <th style='text-align: center'>المقدم</th>
                      <th v-show='typeID === 1 || typeID === 2' style='text-align: center'>الفنى</th>
                      <th v-show='typeID === 0 || typeID === 2' style='text-align: center'>المفوض</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>
                      <td align='center'>{{index+1}}</td>
                      <td align='center'>{{record.rec_id}}{{record.rec_id_letter}}</td>
                      <td align='right'>
                        <a
                          v-show="$per.value.getAllCustomerData"
                          href="#"
                          @click.prevent="openCustomerData(record.uid, record)">
                          {{record.name}}
                        </a></td>
                      <td align='center'>{{record.installtion_date}}</td>
                      <td align='center'>{{record.item}}</td>
                      <td align='center'>{{record.installation_fee}}</td>
                      <td align='center'>{{record.presenter}}</td>
                      <td v-show='typeID === 1 || typeID === 2' align='center'>{{record.tec}}</td>
                      <td v-show='typeID === 0 || typeID === 2' align='center'>{{record.del}}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- /.table-responsive -->
              </div>
              <!-- /.panel-body -->
            </div>
            <!-- /.panel -->
          </div>
          <!-- /.col-lg-12 -->
        </div>
      </div>
      <!-- /.container-fluid -->
      <!-- ================ Contracts Modal Begin ======================================== -->
      <CustomerDetails ref="CustomerDetails"  @return-data="returnData"> </CustomerDetails>
    <!-- ================  /.modal-content ======================================== -->
    </div>
    </template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import CustomerDetails from '@/components/Sales/Customers/CustomerDetails'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  name: 'TellerUsersReport',
  components: {
    tbDate,
    Datepicker,
    CustomerDetails
  },
  data () {
    return {
      ar: ar,
      fromTitle: 'من',
      toTitle: 'إلى',
      from_date: '',
      to_date: '',
      records: {},
      emps: {},
      typeID: null,
      types: [{id: 0, name: 'فنيين'}, {id: 1, name: 'مفوضين'}, {id: 2, name: 'كل الفرع'}],
      branches: [],
      branche_id: '',
      user_id: '',
      isLoadingData: false,
      validationErrors: '',
      t01: '',
      t02: '',
      t03: '',
      t04: '',
      t05: ''
    }
  },
  computed: {
    dateFrom () {
      if (!this.from_date) return ''
      return moment(this.from_date).format('DD-MM-YYYY')
    },
    dateTo () {
      if (!this.to_date) return ''
      return moment(this.to_date).format('DD-MM-YYYY')
    }
  },
  created () {
    this.branche_id = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.getEmp()
  },
  methods: {
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // =====================================================
    getEmp () {
      this.records = null
      if (this.typeID === 0) {
        this.isLoadingData = true
        axios.post(this.$apiURL + 'getBranchTechnicals', {
          token: localStorage.getItem('token'),
          branch_id: this.branche_id
        })
          .then(({ data }) => {
            console.log('fffff')
            this.emps = data
            this.isLoadingData = false
          })
          .catch(err => {
            console.log(err)
            if (err.response.data.errors === 'Forbidden') {
              this.$router.push('accessdeny')
            }
            if (err.response.status === 401) {
              this.$router.push('login')
            }
            this.isLoadingData = false
          })
      } else if (this.typeID === 1) {
        this.isLoadingData = true
        axios.post(this.$apiURL + 'getBranchDelegates', {
          token: localStorage.getItem('token'),
          branch_id: this.branche_id
        })
          .then(({ data }) => {
            this.emps = data
            this.isLoadingData = false
          })
          .catch(err => {
            if (err.response.data.errors === 'Forbidden') {
              this.$router.push('accessdeny')
            }
            if (err.response.status === 401) {
              this.$router.push('login')
            }
            this.isLoadingData = false
          })
      }
    },
    // =====================================================
    GetData () {
      this.isLoadingData = true
      var t = document.getElementById('t01')
      this.t01 = t.options[t.selectedIndex].text
      var t2 = document.getElementById('t02')
      if (t2.selectedIndex > -1) {
        this.t02 = t2.options[t2.selectedIndex].text
      }
      if (this.typeID < 2) {
        var t3 = document.getElementById('t03')
        if (t3.selectedIndex > -1) {
          this.t03 = t3.options[t3.selectedIndex].text
        }
      }
      this.validationErrors = ''
      axios.post(this.$apiURL + 'getTeccontract', {
        token: localStorage.getItem('token'),
        branche_id: this.branche_id,
        user_id: this.user_id,
        from_date: moment(this.from_date).format('YYYY-MM-DD'),
        to_date: moment(this.to_date).format('YYYY-MM-DD'),
        type: this.typeID
      })
        .then(({data}) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          this.records = {}
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    // ===========================================================================
    returnData () {
      // Dont Delete It ####
    },
    // ===========================================================================
    openCustomerData (uid, rec) {
      this.$refs.CustomerDetails.setData(uid, rec)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Reports/TecReport.vue